app.controller('ViewDocumentWindowController', [
    "$scope", "$uibModal", "params", "DocumentsService", "$uibModalInstance", "usSpinnerService",
    function ($scope, $uibModal, params, DocumentsService, $uibModalInstance, usSpinnerService) {
        $scope.doc = params.document;
        $scope.action = params.action;
        $scope.format = "dd-MM-yyyy HH:mm:ss";
        $scope.deadLine = new Date();
        $scope.createDate = $scope.doc.createDate;
        $scope.isRoot = null;
        $scope.myInfo = {};
        $scope.addressees = $scope.doc.infos;
        $scope.addressTree = [];
        $scope.attachments = $scope.doc.attachments;
        $scope.readyToShow = true;
        $scope.showChancelleryButtons = false;
        $scope.showActionButtons = false;
        $scope.basisDocs = [];

        if (params.action == 'shared' && params.shared && !params.shared.readDate) {
            usSpinnerService.spin("root");
            DocumentsService.markSharedDocument({ _id: params.shared._id }).then(function (res) {
                usSpinnerService.stop("root");
            }).catch(function () {
                usSpinnerService.spin("root");
                toastr.error('', 'დაფიქსირდა შეცდომა');
            });
        }

        $scope.list_to_tree = function (list) {
            var map = {}, node, roots = [], i;
            for (i = 0; i < list.length; i += 1) {
                map[list[i]._id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }

            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.resolvedBy && node.resolvedBy._id) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.resolvedBy._id]].children.push(node);
                } else {
                    roots.push(node);
                }
            }

            return roots;
        };

        $scope.getMyInfoStatus = function () {
            for (var i in $scope.addressees) {
                if ($scope.addressees[i]._id == $scope.infoId) {
                    $scope.myInfo = $scope.addressees[i]
                }
            }
        };

        $scope.addressTree = $scope.list_to_tree($scope.addressees);
        $scope.getMyInfoStatus();

        if ($scope.doc.basisFiles && $scope.doc.basisFiles.length) {
            $scope.basisDocs = $scope.basisDocs.concat($scope.doc.basisFiles);
        }
        if ($scope.doc.basisDocs && $scope.doc.basisDocs.length) {
            $scope.basisDocs = $scope.basisDocs.concat($scope.doc.basisDocs);
        }

        $scope.print = function () {
            window.open('documents/export/' + $scope.doc._id);
        };


        $scope.showComment = function (header, text, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "CommentWindowController",
                templateUrl: _pb + 'employee/documents/comment-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            text: text,
                            header: header,
                            action: 'view'
                        };
                    }
                }
            })
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.generateClass = function (status) {
            if (!status || status == 'unread') return 'doc-unread';
            if (status == 'approved') return 'doc-approved';
            if (status == 'read') return 'doc-read';
            if (status == 'returned') return 'doc-returned';
        };

        $scope.generateTooltip = function (status) {
            if (!status || status == 'unread') return 'წაუკითხავი';
            if (status == 'approved') return 'შესრულებული';
            if (status == 'read') return 'წაკითხული';
            if (status == 'returned') return 'მობრუნებული';
        };

        $scope.openBasis = function (basis, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open('documents/export/' + basis._id);
        };

        $scope.close = function () {
            $uibModalInstance.close();
        };
    }]);
